export default __webpack_public_path__ + "static/media/jenny.a094f39d.png";